<template>
  <div class="city-panel h6 w-100">
    <div class="mb-2">
      <span>按首字母：</span>
      <a href="#A">ABCD</a><a href="#E">EFGH</a><a href="#J">JKLM</a><a href="#N">NPQR</a><a href="#S">STWX</a><a
      href="#Y">YZ</a>
    </div>
    <div class="mb-2">
      <span>热门城市：</span>
      <a href="javascript:;" @click="$emit('setCity',hotItem)" v-for="(hotItem,index) in TopOfTheTown" :key="index">{{hotItem.title}}</a>
    </div>
    <div style="height: 400px;">
      <el-scrollbar style="height:400px">
        <div v-for="(cityItem,index) in CityByInitial" class="mb-3" :key="index">
          <p :id="cityItem.letter" class="font-weight-bold border-bottom">{{cityItem.letter}}</p>
          <span class="city-item mb-1 pt-1 cursor-pointer" @click="$emit('setCity',city)"
                v-for="(city,cityIndex) in cityItem.values" :key="cityIndex">{{city.title}}</span>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'ChooseCity',
    computed: {
      ...mapState(['TopOfTheTown', 'CityByInitial']),
    },

  }
</script>

<style lang="scss" scoped>
  .city-panel{ min-height: 500px;}
  a{
    color: dodgerblue;
    text-decoration: none;
    margin-right: 10px;
    &:hover{ color: red; }
  }
  .city-item {
    color: #000;
    margin-right: 10px;
    display: inline-block;
    width:60px;
    padding-left: 5px;
    &:hover{
      color: red;
    }
  }
</style>
